import Flickity from "flickity";

class Carousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carousel = self.elem.querySelector('[data-carousel]');
        self.prevNextButtons = self.elem.getAttribute('data-prev-next-buttons');
    }

    init() {
        let self = this;

        const cellCount = self.carousel.children.length;

        // Flickity options
        let flktyOptions = {
            draggable: true,
            wrapAround: cellCount > 2,
            pageDots: true,
            prevNextButtons: self.prevNextButtons ?? false,
            autoPlay: 4000,
            cellAlign: 'center',
        };

        // Initialise Flickity
        new Flickity(self.carousel, flktyOptions);
    }
}

export default Carousel;